import { AI_REWRITE_CONTENT } from './aiRewrite';
import { AUDIO_DOWNLOAD_CONTENT } from './audioDownload';
import { GLOSSARY_CONTENT } from './glossary';
import { LIP_SYNC_CONTENT } from './lipSync';
import { MULTILANGUAGE_CONTENT } from './multilanguage';
import { SRT_DOWNLOAD_CONTENT } from './srtDownload';
import { SRT_UPLOAD_CONTENT } from './srtUpload';
import { TEAMSPACE_CONTENT } from './teamspace';
import { USER_PROMPTING_CONTENT } from './userPrompting';
import { VIDEO_SUBTITLES_CONTENT } from './videoSubtitles';
import { VOICE_PRESETS_CONTENT } from './voicePresets';

export const CONTENT = {
  aiRewrite: AI_REWRITE_CONTENT,
  audioDownload: AUDIO_DOWNLOAD_CONTENT,
  glossary: GLOSSARY_CONTENT,
  lipSync: LIP_SYNC_CONTENT,
  multilanguage: MULTILANGUAGE_CONTENT,
  srtDownload: SRT_DOWNLOAD_CONTENT,
  srtUpload: SRT_UPLOAD_CONTENT,
  teamspace: TEAMSPACE_CONTENT,
  userPrompting: USER_PROMPTING_CONTENT,
  videoSubtitles: VIDEO_SUBTITLES_CONTENT,
  voicePresets: VOICE_PRESETS_CONTENT,
};
